module.exports = __webpack_public_path__ + "img/nichole.f93b1047.jpg";